import { Container, Grid, Paper } from '@material-ui/core'
import React from 'react'
import { components, useTranslation } from 'cng-web-lib'

import UserForShipperRequestViewForm from './UserForShipperRequestViewForm'
import UserShipperRequestTypeCrudTable from './UserShipperRequestTypeCrudTable'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import UserForShipperRequestKeys from 'src/constants/locale/key/UserForShipperRequest'

const { CngTabs } = components


function ViewPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.USER_FOR_SHIPPER_REQUEST])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let userForShipperRequest = translate(
      Namespace.USER_FOR_SHIPPER_REQUEST,
      UserForShipperRequestKeys.TITLE
    )
    let userShipperRequestType = translate(
      Namespace.USER_FOR_SHIPPER_REQUEST,
      UserForShipperRequestKeys.UserShipperRequestType.TITLE
    )

    return {
      userForShipperRequest,
      userShipperRequestType
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <UserForShipperRequestViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={(datum) => {console.log("UserForShipperRequest View Form")}}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.userForShipperRequest,
              tabContent: (
                <UserForShipperRequestViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
            {
              tabName: translatedTextsObject.userShipperRequestType,
              tabContent: (
                <UserShipperRequestTypeCrudTable
                  showNotification={showNotification}
                  userForShipperRequestId={id}
                  isViewOnly={true}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage